export default __webpack_public_path__ + "static/media/teamwork.148b892d.png";